var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Amazon",
    transform: "translate(-24 -332)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(24 332)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "erply-logo",
    transform: "translate(29.989 337.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M12.773,11.557H5.2l3.581-4.6L7.129,4.864l-.013.016.013-.016L5.205,2.445h7.567L14,0H0L1.925,2.445,5.49,6.964,0,14H13.7Z",
    transform: "translate(-0.99 -0.337)",
    fill: "#6a6d84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErply);
export default __webpack_public_path__ + "static/media/icon-erply.11bae06491a4f5e3ec36930c60404fe7.svg";
export { ForwardRef as ReactComponent };